var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('StoneHeader'),_c('h2',[_vm._v("ここはトップページです。")]),_c('StoneFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }